import React from "react";
import { useNavigate } from "react-router-dom";
import { createBannedIp } from "src/actions/mine_craft/bannedIpsActions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setNewError, setNewParams, BannedIpInterface } from "src/store/mine_craft/bannedIpsSlice";

import Form from './_partials/_Form';
import DrawerRight from "src/componets/DrawerRight";
import AlertBlock from "src/componets/AlertBlock";

const New = () => {
  const navigate = useNavigate();
  const dispatch  = useAppDispatch();
  const newParams = useAppSelector(state => state.mineCraft.bannedIps.newParams);
  const error = useAppSelector(state => state.mineCraft.bannedIps.newError);

  let params = newParams;

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(data: BannedIpInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createBannedIp(data));

    if (createBannedIp.fulfilled.match(resultAction)) {
      onClose();
      navigate(0);
    }
  }

  return (
    <DrawerRight
      open={!!params}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-banned-ip'>
        <h6 className="v-content-label">Ban IP</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
